"use strict";

var __createBinding = Object.create ? function (e, t, i, n) {
  void 0 === n && (n = i), Object.defineProperty(e, n, {
    enumerable: !0,
    get: function get() {
      return t[i];
    }
  });
} : function (e, t, i, n) {
  void 0 === n && (n = i), e[n] = t[i];
},
    __setModuleDefault = Object.create ? function (e, t) {
  Object.defineProperty(e, "default", {
    enumerable: !0,
    value: t
  });
} : function (e, t) {
  e.default = t;
},
    __importStar = function __importStar(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (null != e) for (var i in e) {
    "default" !== i && Object.hasOwnProperty.call(e, i) && __createBinding(t, e, i);
  }
  return __setModuleDefault(t, e), t;
};

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.isClonedItem = exports.isActiveItem = exports.getRenderStageItemClasses = void 0;

var Utils = __importStar(require("."));

exports.getRenderStageItemClasses = function (e, t) {
  void 0 === e && (e = 0);
  var i = t.fadeoutAnimationIndex;
  return "alice-carousel__stage-item" + (exports.isActiveItem(e, t) ? " __active" : "") + (exports.isClonedItem(e, t) ? " __cloned" : "") + (e === i ? " animated animated-out fadeOut" : "");
}, exports.isActiveItem = function (e, t) {
  void 0 === e && (e = 0);
  var i = t.activeIndex,
      n = t.itemsInSlide,
      r = t.itemsOffset,
      o = t.infinite,
      a = t.autoWidth,
      t = Utils.getShiftIndex(n, r);
  if (o && a) return e - t === i + r;
  t = i + t;
  return o ? t <= e && e < t + n : i <= e && e < t;
}, exports.isClonedItem = function (e, t) {
  void 0 === e && (e = 0);
  var i = t.itemsInSlide,
      n = t.itemsOffset,
      r = t.itemsCount,
      o = t.infinite,
      t = t.autoWidth;
  if (!o) return !1;
  if (o && t) return e < i || r - 1 + i < e;
  n = Utils.getShiftIndex(i, n);
  return e < n || r - 1 + n < e;
};